export const enum PlatformTypes {

    UNDEFINED = 'undefined',
    MANUFY = 'manufy',
    CIRCULAR_INNOVATIONS = 'circular_innovations',

}
